import { v4 as uuidv4 } from 'uuid'
import Cookies from 'js-cookie'

export const SESSION_ID_COOKIE_NAME = 'user_session_id'

export const getOrSetSessionId = () => {
  let sessionId = Cookies.get(SESSION_ID_COOKIE_NAME)
  if (!sessionId) {
    sessionId = uuidv4()
    Cookies.set(SESSION_ID_COOKIE_NAME, sessionId, { expires: 1 }) // Expires in 1 day, adjust as needed
  }
  return sessionId
}

export const setSessionId = () => {
  const sessionId = uuidv4()
  Cookies.set(SESSION_ID_COOKIE_NAME, sessionId, { expires: 1 }) // Expires in 1 day, adjust as needed
}
